module.exports={
    "index": {
        "login": "Рейтинг участников",
        "regist": "Подарок новым пользователям",
        "user": "новая команда",
        "jiang": "член",
        "set": "состояние",
        "lingqyu": "Никаких примечаний не было введено, пожалуйста, установите их.",
        "liji": "не был введен. Пожалуйста, установите",
        "list": {
            "0": "Время депозита",
            "1": "Информация о дебетовой карте",
            "2": "Примечание. Пополнение кошельков Bitcoin и USDT. 10 % от суммы пополнения + 20 долларов США без комиссии.",
            "3": "Извините, я не понял, пожалуйста, продолжайте покупку",
            "4": "доллар",
            "5": "Количество заказов в первый день достигло 20 штук, поэтому больше размещать заказы нельзя。",
            "6": "Отправить сейчас"
        },
        "xuanchaun": {
            "xiazai": {
                "0": "банковский счет",
                "1": "отменить заказ"
            },
            "tianjia": {
                "0": "адрес",
                "1": "Адрес не введен. Пожалуйста, укажите адрес"
            },
            "tiqu": {
                "0": "Пожалуйста, зайдите",
                "1": "Баланс счета меньше 200. Пожалуйста, пополните баланс перед получением заказа。"
            }
        },
        "guanyu": {
            "title1": "Проверьте баланс вашего счета",
            "text1": "Недостаточный баланс счета",
            "title2": "Ваш заказ обработан. Пожалуйста, обновите страницу",
            "text2": "Ошибка параметра, проверьте номер заказа."
        },
        "title_content": {
            "0": "Номер заказа не существует",
            "1": "Не удалось получить заказ. В данной ценовой категории недостаточно товаров.",
            "2": "Не удалось получить заказ. Пожалуйста, повторите попытку позже."
        },
        "content": {
            "0": "Заказ успешно получен",
            "1": "На балансе недостаточно средств, поэтому разместите заказ еще раз.",
            "2": "возьми это"
        },
        "dugengduo": "Уровни членства недостаточно сбалансированы",
        "darkgrey": {
            "1": {
                "title": "Прием заказов завершен",
                "text": "Время заезда"
            },
            "2": {
                "title": "возьми красный конверт",
                "text": "идти заряжаться"
            },
            "3": {
                "title": "пожалуйста, посмотрите еще раз",
                "text": "Для разблокировки баланс счета должен быть более 200."
            },
            "4": {
                "title": "следующий шаг",
                "text": "проверочный код"
            },
            "5": {
                "title": "Пожалуйста, введите свой код подтверждения",
                "text": "Проверка кода графической аутентификации не удалась. Пожалуйста, введите еще раз"
            },
            "6": {
                "title": "запрос прошел успешно",
                "text": "Неверный формат номера мобильного телефона"
            }
        },
        "into": {
            "yibiaoban": "Аккаунт не существует",
            "nihao": "пользователь не существует",
            "yue": "Пользователь отключен",
            "shebeigong": "В эту учетную запись уже выполнен вход в другом месте",
            "riqi": "Я несколько раз ввёл неправильный пароль。",
            "gaishu": "Пожалуйста, повторите попытку через несколько минут",
            "kaicaizong": "неправильный пароль",
            "xiaoshili": "Войдите успешно",
            "rili": "Код подтверждения не существует",
            "zhouli": "Ошибка кода подтверждения",
            "yeli": "Код подтверждения недействителен.",
            "tuilian": "Пригласительный код не существует",
            "hezuo": "Рекомендуемые пользователи отключены",
            "fukuanxin": "плохой запрос",
            "tianjiadi": "Пожалуйста, сначала войдите в систему",
            "gengxin": "Эта учетная запись отключена",
            "yibiaoti": "Торговая функциональность для этого счета была заморожена.",
            "yaoqing": "На этом счете есть открытые ордера, и он не может продолжать получать ордера.。",
            "yaoqingren": "Баланс ниже",
            "shijian": "Невозможно продолжить торговлю",
            "choujiangci": "Недостаточное количество транзакций для уровня членства",
            "choujianggai": "интересные сокровища",
            "tuijianren": "Досрочный вывод до истечения срока, без прибыли, без комиссий",
            "xiejie": "Минимальная сумма инвестиций для этого продукта",
            "jiriqi": "Инвестиционный лимит для этого продукта",
            "dianjifu": "Аномалия данных",
            "tishi": {
                "1": "Недостаточно средств на балансе",
                "2": "Успешная операция",
                "3": "Операция не удалась. Проверьте баланс вашего счета。"
            },
            "chongzhijin": "начать инвестировать",
            "chongzhigai": "действовать",
            "nindeyu": "Передача процентного остатка",
            "mianchong": "повторяющееся движение",
            "mianchongci": "Передача процентного остатка",
            "chongzhili": {
                "title": "ошибка параметра",
                "jine": "запрещенный",
                "shijian": "Выполнить текущую операцию вне периода",
                "zhauntai": "Пополнение не может быть меньше этого значения"
            },
            "yijiangli": "Пополнение не может превысить это значение.",
            "yiqizhuan": "ошибка формата изображения",
            "jianglili": "Отправка не удалась. Пожалуйста, повторите попытку позже",
            "shezhi": "оплата в чате",
            "mimashe": "Оплатить с помощью Ali-Pay",
            "dangqianmishu": "Вывод наличных в WeChat",
            "xinmi": "снятие наличных с алипай",
            "shuxinmi": "Данные банковской карты еще не добавлены",
            "quemi": "Пароль транзакции не установлен",
            "shuquemi": "Лимиты вывода средств на уровне членства составляют:",
            "dainyou": "Вывод текущего уровня должен быть завершен",
            "dianyoudi": "заказ",
            "shudainyou": "Недостаточный баланс",
            "fukuanshe": "Сегодня недостаточное количество снятий средств для уровня членства.。",
            "bitedi": "Укажите имя владельца аккаунта.",
            "shugukuan": "Максимальная длина имени владельца учетной записи — 30 символов.",
            "jisheng": "Требуется название банка",
            "qiangou": "требуется номер банковской карты",
            "xiacixiaoshi": "Требуется номер мобильного телефона",
            "yingjian": "Номер банковской карты уже существует",
            "zonggong": "Операция не удалась",
            "maidian": "Страница не существует",
            "yingjiancheng": "получить скидку",
            "zhuanzhang": "Пользователь не авторизован",
            "dianfeizong": "Пожалуйста, не отправляйте повторно",
            "zhuanzhangti": "добиться успеха",
            "zhaunzhangfeiyong": "отказ",
            "zuidifei": "успех",
            "tikuanjin": "Это имя и банковская карта привязаны к другому аккаунту.",
            "zuidixian": "Невозможно удалить адрес доставки по умолчанию.",
            "bijieshou": "Пароль для входа неверен",
            "quezhi": "Я вошёл сегодня",
            "querenti": "Успешно войдите в систему и получите красный конверт.",
            "yiwen": "Вход выполнен успешно",
            "tili": "Все заказы на вывод средств",
            "yaohaoyou": "Проверка пройдена",
            "yaohuoci": "Пожалуйста, войдите, чтобы сделать заказ",
            "yihanwei": "Не удалось получить заказ. Пожалуйста, повторите попытку позже",
            "gongxihuo": "Не удалось получить заказ, товара нет в наличии"
        },
        "taocan": {
            "title": "Мобильный номер зарегистрирован",
            "text": "В течение 1 минуты можно отправить только одно текстовое сообщение.",
            "kuanggong": "Отправлено успешно",
            "liliang": "Отправить не удалось",
            "jiage": "SMS успешно отправлено",
            "yingli": "неполные параметры"
        },
        "baoming": {
            "title": "Серверные пространства не поддерживаются. Убедитесь, что вы поддерживаете curl или fsocket, чтобы решить проблему или изменить пространство.",
            "text": "Срок действия учетной записи истек"
        }
    },
    "login": {
        "yongdeng": "IPограничения по адресу",
        "quedeng": "Контент содержит деликатную лексику",
        "yonghu": "Ошибка параметра продукта",
        "mima": "Недостаточно средств на балансе. Пожалуйста, сначала зарядите",
        "xieyi": "сегодняшняя сумма",
        "tiaokaun": "Количество пользователей сегодня",
        "tongyi": "Количество людей онлайн сегодня",
        "wangmi": "год",
        "zhaomi": "месяц",
        "zhaomiti": "Войти",
        "feihuiyuan": "Непрерывный",
        "lizhi": "Я зарегистрировался сегодня и получил красный конверт.",
        "chaunghu": "день",
        "yonghumming": "один",
        "mimafu": "два",
        "zhanghaoyou": "четыре",
        "jinggao": "Пять"
    },
    "botton": {
        "lianjie": {
            "0": "Шесть",
            "1": "Вошёл в систему",
            "2": "Уже вошёл сегодня",
            "3": "перенос"
        },
        "zhichi": {
            "0": "передача",
            "1": "торговый центр"
        }
    },
    "content": {
        "zhichu": "один",
        "jiage": "второй класс",
        "yinliang": "вообще не разрешено",
        "jiaoyizhe": "Сообщение установки",
        "btbjiage": "R",
        "queren": "100",
        "quxiao": "300",
        "shehe": {
            "0": "500",
            "1": "1000",
            "2": "3000"
        }
    },
    "buchong": {
        "caidan": "5000",
        "dengchu": "10000",
        "shangdian": "30000",
        "dan": "Вы можете получить один аккаунт",
        "choujiang": "плата за генерацию",
        "jiangli": "уровень 1",
        "chongzhi": "3 поколения комиссий",
        "zhuanzhang": "Уровень 3",
        "yongjin": "Загрузить скриншот платежа",
        "lijikaishi": "Поднимите и обновите",
        "mianfei": "Выделенные каналы нового уровня позволяют вам получать более высокие комиссионные.",
        "kaishi": "Потяните вниз, чтобы отсортировать",
        "lianjie": "Младшая комиссионная скидка",
        "zhoumo": "не может быть пустым",
        "shizhi": "специализированное обслуживание клиентов",
        "jiaoyi": "Пароли, введенные дважды, не совпадают",
        "zhichi": "Пароли фондов, введенные дважды, не совпадают",
        "fuzhi": "персональная информация",
        "dangqian": "Чтобы предотвратить мониторинг платформы, например сопоставление заказов;",
        "wanshan": "Пожалуйста, проверьте пароль транзакции",
        "buyizhi": "Сообщение покупателя",
        "ziyou": "учиться",
        "mai": "комиссия второго поколения",
        "yaoqing": "уровень 2",
        "yihan": "QR-код",
        "gongxi": "Управление паролями транзакций",
        "huifu": "Детали транзакции"
    },
    "tanchuang": {
        "one": "Количество заказов сегодня",
        "two": "Я уже заработал комиссию сегодня",
        "title1": "Сегодняшние результаты",
        "title2": "Сегодняшний доход"
    },
    "weishangxian": {
        "weishangxian": "После выполнения вышеуказанных операций обратитесь в службу поддержки клиентов, чтобы повысить свой балл.",
        "yueshouru": "цена",
        "meiyuan": "дальнейшие задачи",
        "qianggouzhong": "миссионерский зал",
        "chongzhidizhi": "скидка на задачу",
        "jine": "купон",
        "bufu": "Членство действительно навсегда",
        "zhengque": "Уровень членства",
        "xuanxiang": "Детали участника",
        "chongzhi": "Записи пополнения и вывода средств Yugataho",
        "xiaoshi": "дополнительный доход от сокровищ",
        "yongjiu": "Дополнительная передача сокровищ",
        "yongjin": "Трансфер Юэхо",
        "renshu": "избыточное сокровище",
        "hezuo": "баланс платежа",
        "fenxiang": "Перевод баланса",
        "chenggong": "баланс",
        "tuijianID": "Привет. Чтобы защитить свои права и интересы, пожалуйста, привяжите правильный номер карты и информацию о филиалах четырех крупнейших банков (Банк Китая, Строительный банк, Промышленно-торговый банк и Сельскохозяйственный банк). Если вы введете неверную информацию, вы не сможете открыть счет. Наша платформа не несет никакой ответственности даже в случае его получения! Платформа не поддерживает снятие наличных в банках, кроме четырех крупнейших банков.",
        "neirong": "комиссия плюс",
        "tuijian": "ставка комиссии"
    },
    "into_one": {
        "yibiaoban": "комиссия",
        "nihao": "Сохраните QR-код в локальном скан-коде",
        "yue": "Сохранено успешно.",
        "shebeigong": "Сохраните скриншот и отсканируйте QR-код для оплаты.",
        "riqi": "Информационное уведомление",
        "gaishu": "переименовывать",
        "kaicaizong": "изменить пароль",
        "xiaoshili": "Изменено успешно",
        "rili": "Бывший",
        "zhouli": "Зарядка",
        "yeli": "Зарядка идет. Пожалуйста, обновите свой баланс позже",
        "tuilian": "Зарядка и обновление",
        "hezuo": "статус зарядки",
        "fukuanxin": "Обновите и разблокируйте",
        "tianjiadi": "Зарядите и разблокируйте",
        "gengxin": "Пополнение заказов в ожидании оплаты",
        "yibiaoti": "Запись пополнения счета",
        "yaoqing": "Процедура зарядки",
        "yaoqingren": "Для зарядки обратитесь в службу поддержки клиентов",
        "shijian": "Сумма платежа",
        "choujiangci": "пополнять",
        "choujianggai": "перезарядка。",
        "tuijianren": "Бесплатная регистрация",
        "xiejie": "Мы усердно работаем над получением заказов, результаты будут объявлены ниже.。",
        "jiriqi": "все продукты",
        "dianjifu": "Вывести все",
        "tishi": {
            "1": "все",
            "2": "замороженный",
            "3": "Если заявка не будет подтверждена в течение нескольких минут, система заморозит сумму заказа.。"
        },
        "chongzhijin": "точка",
        "chongzhigai": "стереть",
        "nindeyu": "Время прибытия: 5 минут",
        "mianchong": "оставшиеся доступные активы",
        "mianchongci": "Загрузка",
        "chongzhili": {
            "title": "Обновление прошло успешно",
            "jine": "Перейти к загрузке",
            "shijian": "иди за заказом",
            "zhauntai": "Перейти, чтобы добавить"
        },
        "yijiangli": "Отправить код подтверждения",
        "yiqizhuan": "отмена",
        "jianglili": "Доступный баланс",
        "shezhi": "Доступный баланс",
        "mimashe": "договор",
        "dangqianmishu": "сотрудничать",
        "xinmi": "имя",
        "shuxinmi": "затем переходит в состояние тайм-аута",
        "quemi": "товар",
        "shuquemi": "Домашняя страница торгового центра",
        "dainyou": "Вернуться на главную страницу",
        "dianyoudi": "Размер команды",
        "shudainyou": "командный баланс",
        "fukuanshe": "Статус комиссии команды",
        "bitedi": "Общая комиссия команды",
        "shugukuan": "Общее пополнение команды",
        "jisheng": "Общий вывод команды",
        "qiangou": "комиссия за командный заказ",
        "xiacixiaoshi": "отчет команды",
        "yingjian": "командный поток",
        "zonggong": "управление командой",
        "maidian": "команда",
        "yingjiancheng": "открыть в браузере",
        "zhuanzhang": "онлайн оплата",
        "dianfeizong": "область",
        "zhuanzhangti": "Скопировано успешно",
        "zhaunzhangfeiyong": "Скопировать ссылку",
        "zuidifei": "клонировать",
        "tikuanjin": "небо",
        "zuidixian": "Настройки аватара",
        "bijieshou": "аватар",
        "quezhi": "Если у вас есть какие-либо проблемы и вам нужна помощь, пожалуйста, свяжитесь с нашей онлайн-службой поддержки клиентов.",
        "querenti": "имя",
        "yiwen": "внести сумму",
        "tili": "Сумма депозита не соответствует системным требованиям",
        "yaohaoyou": "депозит",
        "yaohuoci": "История доступа",
        "yihanwei": "Регулярная гарантия",
        "gongxihuo": "Официально предоставлено"
    },
    "into_two": {
        "yibiaoban": "Регулярное финансовое управление",
        "nihao": "конечно",
        "yue": "Ошибка аудита",
        "shebeigong": "сдал экзамен",
        "riqi": "обслуживание клиентов",
        "gaishu": "обслуживание клиентов",
        "kaicaizong": "сеть связи",
        "xiaoshili": "управление паролями",
        "rili": "Уважаемые пользователи, пожалуйста, укажите свое настоящее имя и установите пароль для вывода средств, чтобы обеспечить безопасность ваших средств. Вы не сможете вывести деньги, если они не совпадают с именем открытия счета.",
        "zhouli": "Пожалуйста, обязательно вводите десятичную точку",
        "yeli": "Через некоторое время система автоматически разморозится.",
        "tuilian": "Проведите пальцем влево или вправо, чтобы увидеть более подробную информацию.",
        "hezuo": "отправил",
        "fukuanxin": "Завершенный",
        "tianjiadi": "отменен",
        "gengxin": "Пожалуйста, введите свой адрес электронной почты",
        "yibiaoti": "У вас уже есть аккаунт? Авторизоваться",
        "yaoqing": "Если у вас уже есть учетная запись, загрузите сейчас",
        "yaoqingren": "Истекший",
        "shijian": "прошедший",
        "choujiangci": "был уволен",
        "choujianggai": "Начни свой путь к богатству",
        "tuijianren": "владелец счета",
        "xiejie": "Договор открытия счета",
        "jiriqi": "Имя учетной записи",
        "dianjifu": "Адрес открытия счета",
        "tishi": {
            "1": "Банк открытия счета",
            "2": "сберегательный банк",
            "3": "доход дня"
        },
        "chongzhijin": "Ожидающие платежи",
        "chongzhigai": "в ожидании",
        "nindeyu": "Ожидание обзора",
        "mianchong": "что следует заплатить",
        "mianchongci": "Ожидание получения",
        "chongzhili": {
            "title": "Чтобы разблокировать",
            "jine": "Вы можете идентифицировать QR-код, нажав и удерживая его прямо в WeChat.",
            "shijian": "забыть пароль",
            "zhauntai": "быстрый вывод денег"
        },
        "yijiangli": "полная перезарядка",
        "yiqizhuan": "Общая сумма вывода",
        "jianglili": "общий доход",
        "shezhi": "общие активы",
        "mimashe": "ваш баланс",
        "dangqianmishu": "Для заказов",
        "xinmi": "Ваш заказ приостановлен. Пожалуйста, подождите некоторое время",
        "shuxinmi": "Срок действия вашего заказа истек и не может быть обработан",
        "quemi": "ваша идентификационная информация",
        "shuquemi": "данные вашей банковской карты",
        "dainyou": "Вы уверены, что хотите удалить этот адрес?",
        "dianyoudi": "Вы еще не добавили данные своей банковской карты",
        "shudainyou": "Я согласен с «Условиями обслуживания»",
        "fukuanshe": "Платеж завершен",
        "bitedi": "Я понимаю и согласен",
        "shugukuan": "мой баланс",
        "jisheng": "моя команда",
        "qiangou": "мои общие активы",
        "xiacixiaoshi": "мой номер мобильного телефона",
        "yingjian": "мой заказ",
        "zonggong": "мой кошелек",
        "maidian": "моя дебетовая карта",
        "yingjiancheng": "мой",
        "zhuanzhang": "скриншот или напрямую",
        "dianfeizong": "банк",
        "zhuanzhangti": "Все продукты",
        "zhaunzhangfeiyong": "различные типы",
        "zuidifei": "номер мобильного телефона указан неверно",
        "tikuanjin": "Номер мобильного телефона введен неверно",
        "zuidixian": "номер телефона",
        "bijieshou": "номер телефона",
        "quezhi": "мобильный телефон",
        "querenti": "комиссия",
        "yiwen": "Получить заказ",
        "tili": "Время получения заказа",
        "yaohaoyou": "номер заказа",
        "yaohuoci": "Запись заказа",
        "yihanwei": "записывать",
        "gongxihuo": "Порядок получения заказов"
    },
    "into_s1": {
        "yibiaoban": "получить заказ",
        "nihao": "количество заказа",
        "yue": "Скидка на комиссию за заказы",
        "shebeigong": "рекламный плакат",
        "riqi": "Рекомендуемое количество человек",
        "gaishu": "Рекомендуемые продукты",
        "kaicaizong": "рекомендовать",
        "xiaoshili": "представлять на рассмотрение",
        "rili": "Отправка прошла успешно. Пожалуйста, подождите некоторое время, пока проверка не будет завершена.",
        "zhouli": "Отправка прошла успешно. Вы будете немедленно перенаправлены",
        "yeli": "Отправить заказ",
        "tuilian": "представлять на рассмотрение",
        "hezuo": "Количество выводов",
        "fukuanxin": "Статус вывода средств",
        "tianjiadi": "Заявка на вывод отправлена",
        "gengxin": "Запись о снятии средств",
        "yibiaoti": "Скорость вывода",
        "yaoqing": "Сумма вывода",
        "yaoqingren": "Лимит на снятие средств",
        "shijian": "отзывать",
        "choujiangci": "поиск",
        "choujianggai": "способ оплаты",
        "tuijianren": "Адрес филиала",
        "xiejie": "получатель",
        "jiriqi": "получатель",
        "dianjifu": "стандарты дохода",
        "tishi": {
            "1": "Тип пособия",
            "2": "Доходы",
            "3": "имя грузополучателя"
        },
        "chongzhijin": "Информация об адресе доставки",
        "chongzhigai": "Изменить адрес доставки",
        "nindeyu": "Изменить адрес доставки",
        "mianchong": "Адрес доставки",
        "mianchongci": "Получение идентификационной информации",
        "chongzhili": {
            "title": "новый человек",
            "jine": "Новый пароль",
            "shijian": "новый номер мобильного телефона",
            "zhauntai": "время"
        },
        "yijiangli": "Вчерашняя командная комиссия",
        "yiqizhuan": "Вчерашняя прибыль",
        "jianglili": "Нет данных",
        "shezhi": "Пока нет записей",
        "mimashe": "Для более подробной информации",
        "dangqianmishu": "более",
        "xinmi": "Банковская карта не привязана. Пожалуйста, свяжите",
        "shuxinmi": "Регион не введен. Пожалуйста, установите",
        "quemi": "Банк открытия счета не указан. Пожалуйста, установите его.",
        "shuquemi": "Адрес филиала не указан. Пожалуйста, установите",
        "dainyou": "Номер телефона не введен. Пожалуйста, установите",
        "dianyoudi": "Номер телефона не введен. Пожалуйста, установите",
        "shudainyou": "Настоящее имя не введено. Пожалуйста, установите",
        "fukuanshe": "Подробный адрес не указан. Пожалуйста, установите",
        "bitedi": "Не введен номер банковской карты. Пожалуйста, установите",
        "shugukuan": "не введен, пожалуйста, установите его.",
        "jisheng": "Эти данные",
        "qiangou": "При выводе средств будет удержана комиссия.",
        "xiacixiaoshi": "Загрузка",
        "yingjian": "Принимаем заказы каждый день",
        "zonggong": "QRКода нет, пожалуйста, нажмите здесь",
        "maidian": "Нет данных",
        "yingjiancheng": "Больше нет контента",
        "zhuanzhang": "Больше нет данных",
        "dianfeizong": "Нет записи",
        "zhuanzhangti": "Время регистрации",
        "zhaunzhangfeiyong": "зарегистрироваться",
        "zuidifei": "Примечание. Из-за большого количества информации о пополнении баланса эта платформа время от времени меняет учетные записи, поэтому, если у вас есть какие-либо вопросы, нажмите «Интернет-служба поддержки клиентов».",
        "tikuanjin": "центр деятельности",
        "zuidixian": "количество активных людей",
        "bijieshou": "Новый адрес доставки",
        "quezhi": "добрые советы",
        "querenti": "состояние",
        "yiwen": "Пополнение счета пользователя",
        "tili": "Имя пользователя не может быть пустым",
        "yaohaoyou": "Ошибка при вводе имени пользователя. Должно содержать от 2 до 12 букв или цифр.",
        "yaohuoci": "Пользователь получает заказ",
        "yihanwei": "Вывод пользователя",
        "gongxihuo": "номер телефона"
    },
    "into_f": {
        "yibiaoban": "пароль для входа",
        "nihao": "Авторизоваться",
        "yue": "Прямо ниже",
        "shebeigong": "Прямо ниже",
        "riqi": "настоящее имя",
        "gaishu": "Подтвердить изменения",
        "kaicaizong": "Проверьте привязку карты",
        "xiaoshili": "конечно",
        "rili": "Проверить пополнение",
        "zhouli": "Хотите подтвердить отмену? В случае отмены сумма будет заморожена?。",
        "yeli": "Подтвердите пароль",
        "tuilian": "Хотите подтвердить вывод этой суммы на свой баланс. За несанкционированный вывод проценты не взимаются! , и вычесть",
        "hezuo": "Хотите подтвердить окончание?",
        "fukuanxin": "Вы вернетесь на мою страницу через несколько секунд.",
        "tianjiadi": "Номер 2",
        "gengxin": "немедленно уйти",
        "yibiaoti": "купить сейчас",
        "yaoqing": "Обновите сейчас",
        "yaoqingren": "Настроить сейчас",
        "shijian": "Ждем подтверждения от покупателя",
        "choujiangci": "Ожидание подтверждения покупателя",
        "choujianggai": "Ожидание ответа торговой системы",
        "tuijianren": "фильтр",
        "xiejie": "введение",
        "jiriqi": "системное уведомление",
        "dianjifu": "Система основана на технологии LBS и автоматически сопоставляет продукты через облако.",
        "tishi": {
            "1": "системная учетная запись",
            "2": "Совокупный доход",
            "3": "онлайн-пополнение"
        },
        "chongzhijin": "оффлайн пополнение",
        "chongzhigai": "Привязать номер мобильного телефона",
        "nindeyu": "привязать банковскую карту",
        "mianchong": "статистика",
        "mianchongci": "Изменить адрес доставки",
        "chongzhili": {
            "title": "Изменить дебетовую карту",
            "jine": "редактировать",
            "shijian": "Сеть нестабильна. Пожалуйста, повторите попытку в месте с хорошим сигналом.",
            "zhauntai": "Сеть нестабильна. Пожалуйста, повторите попытку в месте с хорошим сигналом."
        },
        "yijiangli": "контактный номер",
        "yiqizhuan": "иди за заказом",
        "jianglili": "автоматический",
        "shezhi": "автоматический расчет",
        "mimashe": "Независимый торговый центр",
        "dangqianmishu": "к",
        "xinmi": "Получить код подтверждения",
        "shuxinmi": "правило",
        "quemi": "разблокировать",
        "shuquemi": "номер заказа",
        "dainyou": "Ваш заказ заморожен. Время, необходимое для размораживания, следующее:",
        "dianyoudi": "Время заказа истекло",
        "shudainyou": "Общая сумма вашего заказа",
        "fukuanshe": "общая сумма заказа",
        "bitedi": "Заказ отправляется",
        "shugukuan": "Ваш заказ успешно отправлен",
        "jisheng": "Детали заказа",
        "qiangou": "заказ",
        "xiacixiaoshi": "запомнить пароль",
        "yingjian": "Установить как общий адрес",
        "zonggong": "установить по умолчанию",
        "maidian": "Установите свой аватар",
        "yingjiancheng": "деталь",
        "zhuanzhang": "адрес",
        "dianfeizong": "Пожалуйста, загрузите квитанцию ​​об оплате",
        "zhuanzhangti": "Пожалуйста, загрузите ваучер на пополнение счета",
        "zhaunzhangfeiyong": "Пожалуйста, внимательно проверьте свою платежную информацию",
        "zuidifei": "пожалуйста, заплатите",
        "tikuanjin": "Пожалуйста, измените имя",
        "zuidixian": "Просьба указывать сумму перевода в десятичных знаках, чтобы не влиять на время пополнения.",
        "bijieshou": "Пожалуйста, переведите/переведите средства на счет ниже.",
        "quezhi": "После завершения пополнения счета обратитесь в онлайн-службу поддержки клиентов.",
        "querenti": "Пожалуйста, введите имя пополнения счета",
        "yiwen": "Пожалуйста, введите номер вашего мобильного телефона для пополнения счета",
        "tili": "Пожалуйста, введите сумму платежа",
        "yaohaoyou": "Пожалуйста, введите свое имя",
        "yaohuoci": "Пожалуйста, введите номер вашего мобильного телефона",
        "yihanwei": "Пожалуйста, введите действительный номер мобильного телефона",
        "gongxihuo": "Пожалуйста, введите ваш подробный адрес"
    },
    "into_s": {
        "yibiaoban": "Пожалуйста, введите подробный адрес доставки",
        "nihao": "Пожалуйста, будьте осторожны, чтобы не забыть свой пароль. Если вы забыли свой пароль, обратитесь в службу поддержки клиентов.",
        "yue": "Обратитесь в онлайн-службу поддержки клиентов (Платформа может время от времени менять учетные записи)",
        "shebeigong": "Пожалуйста, введите пароль транзакции",
        "riqi": "Пожалуйста, введите сумму платежа",
        "gaishu": "Пожалуйста, введите исходный пароль",
        "kaicaizong": "Введите свой пароль",
        "xiaoshili": "Пожалуйста, введите имя владельца счета",
        "rili": "Пожалуйста, введите номер мобильного телефона владельца счета",
        "zhouli": "Пожалуйста, введите адрес банка для открытия счета",
        "yeli": "Пожалуйста, укажите банк, в котором открывается счет",
        "tuilian": "Пожалуйста, укажите банк, в котором вы открыли счет",
        "hezuo": "Пожалуйста, введите новый пароль",
        "fukuanxin": "Пожалуйста, введите свой номер телефона",
        "tianjiadi": "Пожалуйста, введите код подтверждения вашего мобильного телефона",
        "gengxin": "Пожалуйста, введите ваш реферальный код",
        "yibiaoti": "Пожалуйста, введите сумму вывода",
        "yaoqing": "Пожалуйста, введите имя получателя",
        "yaoqingren": "Пожалуйста, введите новый пароль",
        "shijian": "Пожалуйста, введите номер вашего мобильного телефона или адрес электронной почты",
        "choujiangci": "Пожалуйста, введите свое имя пользователя",
        "choujianggai": "Пожалуйста, введите свой пароль для входа",
        "tuijianren": "SMSПожалуйста, введите свой код подтверждения",
        "xiejie": "Пожалуйста, введите свой аккаунт/пароль",
        "jiriqi": "Пожалуйста, введите пароль вашего фонда",
        "dianjifu": "Пожалуйста, введите сумму перевода",
        "tishi": {
            "1": "Пожалуйста, введите код приглашения",
            "2": "Пожалуйста, введите номер вашей банковской карты",
            "3": "Пожалуйста, введите свой код подтверждения"
        },
        "chongzhijin": "Пожалуйста, выберите канал оплаты",
        "chongzhigai": "Пожалуйста, выберите канал оплаты",
        "nindeyu": "Пожалуйста, выберите адрес доставки",
        "mianchong": "Выберите уровень, до которого хотите повыситься",
        "mianchongci": "баланс счета",
        "chongzhili": {
            "title": "Замороженная сумма счета",
            "jine": "Детали аккаунта",
            "shijian": "Сумма счета",
            "zhauntai": "Доход от покупок"
        },
        "yijiangli": "Если вы хотите совершить покупку, не вводя свое настоящее имя, укажите его.",
        "yiqizhuan": "При покупке финансовых продуктов, если покупка является злонамеренной, прибыль не будет рассчитана и взимается комиссия.",
        "jianglili": "купить",
        "shezhi": "Пароль фонда",
        "mimashe": "перенаправить",
        "dangqianmishu": "Чтобы отправить деньги, скопируйте сообщение и перейдите в онлайн-банкинг или Alipay, чтобы завершить перевод и пополнить счет.",
        "xinmi": "Пожалуйста, введите сумму пополнения",
        "shuxinmi": "введите имя",
        "quemi": "Пожалуйста, введите сумму депозита",
        "shuquemi": "Введите номер вашего мобильного телефона",
        "dainyou": "Пожалуйста, введите пароль вашего фонда",
        "dianyoudi": "возвращаться",
        "shudainyou": "возвращаться",
        "fukuanshe": "Адрес сбора урожая еще не добавлен",
        "bitedi": "Банковская карта еще не добавлена",
        "shugukuan": "Пожалуйста, зайдите в магазин и посмотрите",
        "jisheng": "удаленный хост выделяет",
        "qiangou": "выход",
        "xiacixiaoshi": "Выберите способ зарядки",
        "yingjian": "Пожалуйста, выберите способ вывода средств",
        "zonggong": "Пожалуйста, выберите количество",
        "maidian": "Выберите финансовый продукт",
        "yingjiancheng": "пригласить друзей",
        "zhuanzhang": "Присоединяйтесь и получайте больше преимуществ",
        "dianfeizong": "код приглашения",
        "zhuanzhangti": "Ссылка-приглашение: нажмите, чтобы скопировать",
        "zhaunzhangfeiyong": "Пожалуйста, внимательно проверьте свою платежную информацию",
        "zuidifei": "снятие наличных с финансовой карты",
        "tikuanjin": "счет дебетовой карты",
        "zuidixian": "банковская карта",
        "bijieshou": "название банка",
        "quezhi": "вопрос",
        "querenti": "Если вам нужна помощь, вы можете обратиться в службу поддержки клиентов, чтобы пополнить баланс вручную.",
        "yiwen": "нужно отплатить",
        "tili": "Предполагаемый доход",
        "yaohaoyou": "ожидаемая доходность",
        "yaohuoci": "Количество первых депозитов",
        "yihanwei": "крышка",
        "gongxihuo": "Пожалуйста, зарядите сейчас"
    },
    "into_se": {
        "yibiaoban": "проверочный код",
        "nihao": "по умолчанию",
        "yue": "Чтобы отсканировать QR-код, вручную сделайте снимок экрана приложения и сохраните его локально.",
        "shebeigong": "Пожалуйста, используйте приложение вручную",
        "riqi": "дом",
        "gaishu": "пароль вход",
        "kaicaizong": "Еще не отправлено",
        "xiaoshili": "Регистрация завершена",
        "rili": "Обновляемый",
        "zhouli": "не могу обновить",
        "yeli": "Вы не сможете обновиться, если не соответствуете условиям обновления.",
        "tuilian": "Критерии обновления достигнуты и обновление завершено",
        "hezuo": "системное уведомление",
        "fukuanxin": "Недостаточный баланс пользователя",
        "tianjiadi": "Недостаточно приглашенных пользователей",
        "gengxin": "Условия обновления не выполнены",
        "yibiaoti": "Требуемый баланс счета превышает следующую сумму",
        "yaoqing": "приглашать",
        "yaoqingren": "разблокировать",
        "shijian": "адрес кошелька",
        "choujiangci": "Возможен перевод через сканирование кошелька.",
        "choujianggai": "Сегодняшняя командная комиссия",
        "tuijianren": "Загрузите приложение",
        "xiejie": "бонус пополнения счета",
        "jiriqi": "TRC20Пожалуйста, введите ваш адрес",
        "dianjifu": "ERC20Пожалуйста, введите ваш адрес",
        "tishi": {
            "1": "О нас",
            "2": "агент",
            "3": "правило"
        },
        "chongzhijin": "введение",
        "chongzhigai": "квалификация",
        "nindeyu": "Сюрприз, когда вы откроете подарочную коробку",
        "mianchong": "быстро заработать деньги",
        "mianchongci": "Старый пароль",
        "chongzhili": {
            "title": "Пожалуйста, введите свой старый пароль",
            "jine": "Пожалуйста, введите свой пароль еще раз",
            "shijian": "Пароль обновлен",
            "zhauntai": "Сменить пароль не удалось"
        },
        "yijiangli": "Пожалуйста, установите флажок, если вы согласны",
        "yiqizhuan": "Критерии обновления соблюдены и обновление выполнено автоматически.",
        "jianglili": "Понижен из-за изменений баланса",
        "shezhi": "системное уведомление",
        "mimashe": "торговый приказ",
        "dangqianmishu": "Система заставила вас заплатить. Если у вас есть какие-либо вопросы, пожалуйста, свяжитесь со службой поддержки клиентов.",
        "xinmi": "Включите автоматический захват заказов",
        "shuxinmi": "Отключить автоматический захват заказов",
        "quemi": "Повторяющееся имя пользователя",
        "shuquemi": "Понижен из-за изменений баланса",
        "dainyou": "Критерии обновления соблюдены и обновление выполнено автоматически.",
        "dianyoudi": "телефон",
        "shudainyou": "О нас",
        "fukuanshe": "Смотреть сейчас",
        "bitedi": "платформа",
        "shugukuan": "объявление",
        "jisheng": "Приглашайте друзей и зарабатывайте деньги",
        "chongxindenglu": "Пожалуйста, войдите еще раз",
        "pingtaijianjie": "Введение в платформу",
        "pingtaijianjie1": "Правила приема заказов",
        "pingtaijianjie2": "Агентское сотрудничество",
        "pingtaijianjie3": "Квалификация компании"
    },
    "qing_sd": "пожалуйста, подождите",
    "loading1": "онлайн-прокси",
    "loading2": "запросить заказ",
    "loading3": "Получить заказ",
    "goods": {
        "0": "зеленое стекло",
        "1": "уникальные средства по уходу за кожей",
        "2": "пищевой пластиковый стаканчик",
        "3": "классические духи",
        "4": "импортный кофе в зернах",
        "5": "Медведь в стиле Диснея"
    },
    "tab_name": {
        "0": "крышка",
        "1": "История заказов",
        "2": "разместить заказ",
        "3": "обслуживание клиентов",
        "4": "мой"
    },
    "pingjia": "оценивать",
    "login_t1": "Единый магазин для покупок по всему миру и получения скидок",
    "zhangh": "Пожалуйста, введите мобильный телефон",
    "email": "Электронная почта",
    "use_app": "Используйте приложение",
    "index_t1": "При первой покупке приложения действует дополнительная скидка 30 % + кэшбэк 10 % + условия бесплатной доставки.",
    "qianbao": "кошелек",
    "huoqu_yj": "зарабатывать комиссию",
    "zhangh_ye": "баланс счета",
    "zhangh_je": "баланс счета",
    "huoq_yj": "зарабатывать комиссию",
    "dingd_s": "количество заказа",
    "caoz_bz": "шаг",
    "caoz_t1": "1.Нажмите кнопку «Начать задачу» и следуйте инструкциям для завершения задачи.",
    "caoz_t2": "2.После выполнения задания вы можете погасить комиссию на баланс",
    "kefu_t1": "Есть вопросы или нужна помощь?",
    "kefu_t2": "Пожалуйста, свяжитесь с онлайн-службой поддержки клиентов, чтобы решить проблему.",
    "kefu_t3": "Выделенное обслуживание клиентов",
    "changj_wtjd": "Часто задаваемые вопросы",
    "changj_wt": {
        "0": {
            "name": "Какие способы пополнения и оплаты доступны?",
            "value": "Система доступна во многих странах, а предлагаемые нами международные способы оплаты включают USDT (ERC20). В то же время он также поддерживает валюты разных стран."
        },
        "1": {
            "name": "Как я могу инвестировать и получать доход?",
            "value": "Вы можете участвовать в торговле сырьевыми товарами в системе и получать стабильный доход от торговли каждый день. Вы можете вывести весь свой заработок на свою банковскую карту."
        },
        "2": {
            "name": "Как мне зарегистрироваться в качестве участника?",
            "value": "В целях обеспечения дохода зарегистрированных участников и предотвращения снижения дохода из-за чрезмерной регистрации регистрация новых участников производится только по приглашению существующего участника."
        },
        "3": {
            "name": "Есть ли ограничение на сумму покупки？",
            "value": "Да, чтобы дать большему количеству участников возможность получить выгоду, для каждой учетной записи в системе установлен минимальный лимит покупок."
        }
    },
    "yonghu_m": "имя пользователя",
    "shoukuan_zh": "дебиторская задолженность",
    "youxiang": "почта",
    "zhanghao": "счет",
    "xiugai_mima": "изменить пароль",
    "xuanze_yy": "Пожалуйста, выберите язык",
	queren:'подтверждать',
	bangka:'Пожалуйста, привяжите свой платежный счет',
	xingy_d:'Поздравляем, вы выиграли счастливый заказ'
}